import 'moment';

class OrderListController {

    constructor($rootScope, $scope, $state, ordersApiService, messageService, access, reportsService, $stateParams) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
        this.access = access;
        this.reports = reportsService;
        this.$stateParams = $stateParams;
    }

    $onInit () {
        this.filtertype = this.$stateParams.filtertype || 'id';
        this.filtertext = this.$stateParams.filtertext || null;

        if (this.filtertext) {
            this.isFiltered = true;
        }

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.orders = undefined;
                        scope.$ctrl.ordersApiService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
                            scope.$ctrl.orders = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        scope.$ctrl.ordersApiService.findPayment(newVal, scope.per_page)
                            .then(list => scope.$ctrl.orders = list);
                    }
                }
            }
        );

        this.ordersApiService.getOrderStatuses().then(response => {
            this.order_statuses = response;
        });

        this.ordersApiService.getPaymentStatuses().then(response => {
            this.payment_statuses = response;
        });
    }

    updatePaging () {
        if (this.orders) {
            this.$scope.per_page = this.orders.per_page;
            this.$scope.current_page = this.orders.current_page;
            this.$scope.total = this.orders.total;
        }
    }

    onDelete (order) {
        const orderReference = order.order_reference;

        return this.ordersApiService.delete(order.id)
            .then(() => {
                this.messageService.success(`The order <strong>${orderReference}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The order <strong>${orderReference}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.orders.current_page;
                this.orders = [];
                this.loading = true;
                return this.ordersApiService.findAll(page).then(response => {
                    this.orders = response;
                    this.loading = false;
                });
            });
    }

    formatTime (dateTime) {
        return moment(`${dateTime}+00:00`).format('LLLL');
    }

    humanTime (dateTime) {
        return moment(`${dateTime}+00:00`).fromNow();
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.ordersApiService.search(this.filtertype, this.filtertext, this.deleted).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        this.startFilter();
        this.ordersApiService.findAll(1, 20).then(response => {
            this.isFiltered = false;
            this.endFilter(response);
        });
    }

    filtertypeChange () {
        this.isFiltered = false;
        switch (this.filtertype) {
            case 'order_status_id':
                this.filtertext = 'processing';
                break;
            case 'payment_status_id':
                this.filtertext = '200';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    displayFiltertype () {
        return this.filtertype.replace(/[._]/, ' ');
    }

    startFilter () {
        this.download = undefined;
        this.orders = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.orders = response;
        this.updatePaging();
        this.loading = false;
    }

    generateReport () {
        this.generating = true;

        let query = {
            type: 'order'
        };

        switch (this.filtertype) {
            case 'id':
                query.order = this.filtertext;
                break;
            case 'customer.name':
                query.name = this.filtertext;
                break;
            case 'customer.email':
                query.email = this.filtertext;
                break;
            case 'order_status_id':
                query.status = this.filtertext;
                break;
            case 'payment_status_id':
                query.payment = this.filtertext;
                break;
            case 'created_at':
                query.datecreated = (this.filtertext ? this.filtertext.format('YYYY-MM-DD') : undefined);
                break;
            case 'reference':
                query.external = this.filtertext;
                break;
        }

        this.reports.generate(query).then(response => {
            this.download = response.link;
            this.filename = response.name;
            this.generating = false;
        }).catch(() => {
            this.messageService.failure('Unfortunately that report could not be generated, please try again.');
            this.messageService.push();
            this.messageService.autoClear();
            this.generating = false;
        });
    }
}

OrderListController.$inject = ['$rootScope', '$scope', '$state', 'ordersApiService', 'messageService', 'access', 'reportsService', '$stateParams'];

export default OrderListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.list.controller.js